import { render, staticRenderFns } from "./propertyList.vue?vue&type=template&id=4674ff70&scoped=true&"
import script from "./propertyList.vue?vue&type=script&lang=js&"
export * from "./propertyList.vue?vue&type=script&lang=js&"
import style0 from "./propertyList.vue?vue&type=style&index=0&id=4674ff70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674ff70",
  null
  
)

export default component.exports